import ScalarDropdown_vue_vue_type_script_setup_true_lang_default from "./ScalarDropdown.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarDropdown/ScalarDropdown.vue
var ScalarDropdown_default = ScalarDropdown_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarDropdown_default as default };

//# sourceMappingURL=ScalarDropdown.vue.js.map